import React from 'react'
import { useIdentity } from '@/hooks/auth/useIdentity'

import { AssistantContainer } from '@features/assistant'
import { isProjectHubRole } from 'src/utils/projectHubRole'
import type { Account } from 'types'

/**
 * Mount point used by the Refine layout (frontend/src/components/layout/layout/index.tsx).
 * Hosts the Assistant right-rail on allow-listed routes.
 *
 * Project-hub roles (SALESMAN + SOCIETY) don't get the assistant buddy
 * (#321 phase 2 follow-up) — their UX uses the simplified per-page chrome.
 */
export const OffLayoutArea: React.FC = () => {
  const { data: identity } = useIdentity<Account>()
  if (isProjectHubRole(identity?.account_type)) return null
  return <AssistantContainer />
}
